import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./BottomButtons.scss";
import { Button } from "react-bootstrap";
import { URLS } from "@/utils/constants";
import { setShowCart } from "@/utils/constants/redux/sets";
export const BottomButtons = ({ navigate }) => {
    return (_jsxs("div", { className: "fmc-store-cart-buttons mt-1 pt-4", children: [_jsx(Button, { onClick: () => {
                    navigate(URLS.store);
                    setShowCart(false);
                }, variant: "secondary", className: "mb-3 mx-3", children: "Seguir comprando" }), _jsx(Button, { onClick: () => {
                    setShowCart(false);
                    navigate(URLS.checkout);
                }, className: "fmc-button mb-3 mx-3", children: "Finalizar compra" })] }));
};
